up.compiler('.blog-article table', (table) => {
  const tableContainer = document.createElement('div')
  tableContainer.classList.add('table-container')
  table.parentNode!.insertBefore(tableContainer, table)
  tableContainer.appendChild(table)
})
